import React, { useRef } from 'react';
import { connect } from 'react-redux';
import { PageLoader } from '../../../../../../Common/Components/PageLoader';
import moment from 'moment';
import inrInWords from '../../../../../../../Utils/INRToWords';
import {numberWithCommas} from '../../../../../../../Utils/NumberToComma';
import { useReactToPrint } from 'react-to-print';
import { PDFExport } from '@progress/kendo-react-pdf';
import MseLogo from "./MseLogo.png"

function MSEE({ data, defaultBank }) {
  if (!data) return <PageLoader />;
  const pdf = useRef(null);

  let totalBaseAmount = 0;
  let totalTax = 0;
  let grandTotal = 0;
  let paymentTerms = [];

  data.procured.forEach((val) => {
    totalBaseAmount += val.base;
    totalTax += val.tax;
    grandTotal += val.amount;
  });
  data.payments.forEach((val) => {
    paymentTerms.push(val.title);
  });

  const getFormValue = (id) => {
    const form = data.forms.find(form => form.id === id);
    return form ? form.value : 'NA';
  };

  const formValues = {
    quoteReference: getFormValue('quote_reference'),
    warrantyPeriod: getFormValue('warranty_period'),
    supportPeriod: getFormValue('support_period'),
    freight: getFormValue('freight'),
    noteToVendor: getFormValue('note_to_vendor')
  };

  const printForm = useReactToPrint({
    content: () => pdf.current,
    documentTitle: data.orderId,
  });

const styles = {
    container: {
      fontFamily: "Arial, sans-serif",
      background: "#F8F8FF",
      padding: 24,
      margin: "8px auto",
      marginBottom:"26px",
      border: "1px solid #ddd",
      borderRadius: 8,
      fontSize: 14,
      color: "#222",
    },
    header: {
      display: "flex",
      alignItems: "center",
      borderBottom: "2px solid #f5b041",
      paddingBottom: 16,
      marginBottom: 16,
    },
    logo: {
      height: 56,
      marginRight: 20,
    },
    title: {
      fontWeight: 700,
      fontSize: 14,
      letterSpacing: 1,
      marginBottom: 4,
    },
    poNumber: {
      textAlign: "center",
      fontWeight: 700,
      fontSize: 18,
    },
    section: {
      marginBottom: 18,
    },
    sectionTitle: {
      fontWeight: 700,
      marginBottom: 6,
      fontSize: 16,
    },
    sectionDescription: {
        fontWeight: 400,
        marginBottom: 6,
        fontSize: 14,
        color: "#2e4053",
      },
    row: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: 4,
    },
    col: {
      flex: 1,
      minWidth: 180,
      marginRight: 18,
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: 12,
      marginBottom: 12,
    },
    th: {
      background: "#f2f2f2",
      border: "1px solid #ddd",
      padding: 4,
      fontWeight: 700,
      fontSize: 12,
    },
    td: {
      border: "1px solid #ddd",
      padding: 4,
      fontSize: 10,
      verticalAlign: "top",
    },
    totals: {
      textAlign: "right",
      fontWeight: 700,
      fontSize: 14,
      paddingRight: 12,
    },
    note: {
      background: "#f9f9f9",
      padding: 10,
      borderRadius: 4,
      marginTop: 20,
      fontSize: 13,
      color: "#616161",
    },
    computerNote: {
      textAlign: "center",
      marginTop: 18,
      fontSize: 13,
      color: "#616161",
    },
  };

  return (
    <>
        <div style={{ textAlign: "right" }}>
              <p
                style={{
                  fontWeight: 600,
                  color: "var(--primary-color)",
                  cursor: "pointer",
                  marginBottom: "10px",
                }}
                onClick={() => {
                  printForm();
                }}
              >
                Print
              </p>
        </div>
        <PDFExport
            paperSize="A4"
            title="Order Document"
            padding="40"
            fileName={`Order-${data.orderId}.pdf`}
            ref={(r) => (pdf.current = r)}
        >
            <div style={styles.poNumber}>{data.orderId}</div>
                <div style={{width:'100%',...styles.container}}>
                    <div style={{...styles.row}}>
                        <div style={styles.col}>
                            <img
                            src={MseLogo}
                            alt="XMSE Logo"
                            style={styles.logo}
                            />
                            <div style={{width:'350px',fontSize:14}}>
                                <div style={styles.title}>Metropolitan Stock Exchange of India Ltd</div>
                                <p >Bussiness Address: </p>
                                <div style={{paddingTop:8,marginBottom:8,fontSize:14}}>
                                    {data.billingTo.registered_name}
                                </div>
                                <div style={{paddingBottom:8,paddingTop:8}}>
                                    {data.details.officeAddress}
                                </div>
                                <div>GSTIN - {data.billingTo.gstin}</div>
                            </div>
                        </div>
                        <div style={{width:'250px',fontSize:14,...styles.section}}>
                            <div style={{textAlign:'center',padding:6,borderRadius:'5%',border:'1px solid gray',...styles.sectionTitle}}>PURCHASE ORDER</div>
                            <div style={styles.col}>
                                <div style={styles.row}><p>PO Number:</p><p style={{textAlign:'right'}}><b> {data.orderId}</b></p></div>
                                <div style={styles.row}><p>PO Date: </p><p style={{textAlign:'right'}}><b>{moment(data.details.createdAt).format('MMM-DD-YYYY')}</b></p></div>
                                <div style={styles.row}><p>Expected Delivery Date:</p><p style={{textAlign:'right'}}> <b>{moment(data.endDate).format('MMM-DD-YYYY')}</b></p></div>
                                <div style={styles.row}><p>Payment Term:</p>
                                    {
                                        paymentTerms.length > 0 ?
                                        paymentTerms.map((term,index)=>{
                                            return (
                                                <p style={{textAlign:'right'}}><b>{term}</b></p>
                                            )
                                        })
                                        :
                                        <p style={{textAlign:'right'}}><b>NA</b></p>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style={{paddingTop:14,...styles.section}}>
                        <div style={styles.row}>
                        <div style={{fontSize:14,...styles.col}}>
                            <p style={{paddingBottom:6}}>Note to Vendor:</p><b>{formValues.noteToVendor}</b>
                        </div>
                        <div style={{fontSize:14,...styles.col}}>
                            <p style={{paddingBottom:6}}>Quote reference:</p><b>{formValues.quoteReference}</b>
                        </div>
                        <div style={{fontSize:14,...styles.col}}>
                            <p style={{paddingBottom:6}}>Warranty:</p><b>{formValues.warrantyPeriod}</b>
                        </div>
                        <div style={{fontSize:14,...styles.col}}>
                            <p style={{paddingBottom:6}}>Support Period:</p><b>{formValues.supportPeriod}</b>
                        </div>
                        <div style={{fontSize:14,...styles.col}}>
                            <p style={{paddingBottom:6}}>Freight:</p><b>{formValues.freight}</b>
                        </div>
                        </div>
                    </div>
                </div>
                <div style={{display: "flex", justifyContent: "space-between", marginBottom: 16,gap:14}}>
                    <div style={{width:'25%',...styles.section}}>
                        <div style={{color:"#1E90FF",...styles.sectionTitle}}>Vendor Details</div>
                        <div style={styles.sectionDescription}>
                            <b>Name</b>: <b>{data.vendor.name}</b><br />
                            <p style={{paddingBottom:4,paddingTop:4}}><b>PAN Number</b>: {data.vendor.pan || 'NA'}</p><br />
                            <p style={{paddingBottom:4}}><b>GSTIN</b>: {data.vendor.gstin || 'NA'}</p><br />
                            <b>Location</b>: {data.vendor.address.city} - {data.vendor.address.state}<br />
                        </div>
                    </div> 

                    <div style={{width:'25%',...styles.section}}>
                        <div style={{color:"#1E90FF",...styles.sectionTitle}}>Vendor Address</div>
                        <div style={styles.sectionDescription}>
                        <b>{data.vendor.address.title}</b> <br/>
                        <p style={{paddingTop:8,paddingBottom:8}}>{data.vendor.address.address}</p>
                            <b>GST Number</b>: {data.vendor.address.gstin || 'NA'}<br />
                        </div>
                    </div>

                    <div style={{width:'25%',...styles.section}}>
                        <div style={{color:"#1E90FF",...styles.sectionTitle}}>Buyer Billing Address</div>
                        <div style={styles.sectionDescription}>
                        <b>{data.billingTo.registered_name}</b><br />
                        <p style={{paddingTop:8,paddingBottom:8}}>{data.billingTo.address}</p><br />
                        <b>GST Number</b>: {data.billingTo.gstin}<br />
                        </div>
                    </div>

                    <div style={{width:'25%',...styles.section}}>
                        <div style={{color:"#1E90FF",...styles.sectionTitle}}>Buyer Shipping Address</div>
                        <div style={styles.sectionDescription}>
                        <b>
                          {data && data.procured && data.procured.length > 0
                            ? data.procured[0].officeRegisteredName || data.procured[0].officeName
                            : data && data.billingTo && data.billingTo.registered_name}
                        </b>
                        <br />
                        <p style={{ paddingTop: 8, paddingBottom: 8 }}>
                          {
                            data && data.procured && data.procured.length > 0
                              ? data.procured[0].officeAddress
                              : data && data.billingTo && data.billingTo.address
                          }
                        </p>
                        <br />
                        <b>GST Number</b>: {
                          data && data.procured && data.procured.length > 0
                            ? data.procured[0].officeGstin
                            : data && data.billingTo && data.billingTo.gstin
                        }<br />
                        </div>
                    </div>
            </div>
            <table style={{width:'100px',...styles.table}}>
                <thead>
                <tr>
                    <th style={styles.th}>#</th>
                    <th style={styles.th}>Name/Description</th>
                    <th style={styles.th}>Comment</th>
                    <th style={styles.th}>Qty</th>
                    <th style={styles.th}>HSN SAC</th>
                    <th style={styles.th}>Unit of Measurement</th>
                    <th style={styles.th}>Rate</th>
                    {/* <th style={styles.th}>Discount</th> */}
                    <th style={styles.th}>Tax (SGST + CGST)</th>
                    <th style={styles.th}>Tax Percentage</th>
                    <th style={styles.th}>Total</th>
                </tr>
                </thead>
                <tbody>
                    {
                        data.procured.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td style={styles.td}>{index + 1}</td>
                                    <td style={styles.td}>{item.name}</td>
                                    <td style={styles.td}>{item.notes}</td>
                                    <td style={styles.td}>{item.qtty}</td>
                                    <td style={styles.td}>{item.hsn}</td>
                                    <td style={styles.td}>{item.unit}</td>
                                    <td style={styles.td}>₹{numberWithCommas(item.price)}</td>
                                    {/* <td style={styles.td}>₹{item.amount}</td> */}
                                    <td style={styles.td}>₹{item.tax}</td>
                                    <td style={styles.td}>{item.taxSlab} %</td>
                                    <td style={styles.td}>₹{numberWithCommas(item.amount)}</td>
                                </tr>
                            );
                        }
                        )
                    }
                </tbody>
            </table>

            <div style={{display: "flex", justifyContent: "space-between",...styles.section}}>
                <div style={{width:'60%',fontSize:14}}><b>Net Total Amount in Words:</b> {inrInWords(grandTotal)}</div>
                <div>
                    <div style={{display:'flex',justifyContent:'space-between'}}><p style={styles.totals}>Total:</p><p style={{fontSize:12}}> ₹{numberWithCommas(totalBaseAmount)}</p></div>
                    {/* <div style={{display:'flex',justifyContent:'space-between'}}><p style={styles.totals}>Discount:</p><p style={{fontSize:12}}> ₹0.0</p></div> */}
                    <div style={{display:'flex',justifyContent:'space-between',paddingBottom:8,paddingTop:8}}><p style={styles.totals}>Tax (SGST + CGST):</p><p style={{fontSize:12}}> ₹{totalTax}</p></div>
                    <div style={{display:'flex',justifyContent:'space-between'}}><p style={styles.totals}>Net Total:</p><p style={{fontSize:12}}> ₹{numberWithCommas(grandTotal)}</p></div>
                </div>
            </div>

            <div style={styles.note}>
                <b style={{color:'#1E90FF'}}>Note to Vendor</b><br />
                {
                    data.forms.map((form,index)=>{
                        if(form.id!=='note_to_vendor') return null;
                        return (
                            <div key={index} style={{marginTop:8}}>
                                <p style={{fontWeight:600}}>* {form.value}</p>
                            </div>
                        )
                    })
                }
                {/* * Termination: Both parties can terminate contract by giving one month advance notice in writing. */}
            </div>
            <div style={styles.computerNote}>
                This is a computer generated document. No signature is required.
            </div>
      </PDFExport>
    </>
  );
}

export default connect((state) => ({ config: state.auth.config }))(MSEE);